var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0V35.97H67.66V0H139.13ZM0.5 56.56V92.42H44.41V56.56H0.5ZM44.42 0H0.5V35.97H44.41V0H44.42ZM67.66 92.42H139.13V56.56H67.66V92.42Z",
    fill: "#CD1420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.18 41.18V0H50.9V41.18H0.5V51.47H50.9V92.42H61.18V51.47H139.13V41.18H61.18Z",
    fill: "#293E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 51.47V92.42H44.42V56.56H0.5V51.47H50.9ZM61.18 92.42H67.66V56.56H139.13V51.47H61.18V92.42ZM67.66 0H61.18V41.18H139.14V35.98H67.66V0ZM50.9 0H44.42V35.97H0.5V41.17H50.9V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNo);
export default __webpack_public_path__ + "static/media/Flag_NO.0cdf9c686b734ed08bcbd65ae74f251e.svg";
export { ForwardRef as ReactComponent };